import { useEffect, useContext } from "react";
import { useRouter } from "next/router";
import { UserContext } from "context/user";
import { AppContext } from "context/app";
import { isTenantReadOnly } from "@pepdirect/v3/helpers/tenant";

export function useRedirectIfLoggedIn(): void {
  const { tenant } = useContext(AppContext);
  const { currentUserId } = useContext(UserContext);
  const router = useRouter();
  const readOnly = isTenantReadOnly(tenant);

  useEffect(() => {
    if (currentUserId) {
      router.push(readOnly ? "/" : "/home");
    }
  }, [currentUserId, router, readOnly]);
}
